import React, { useEffect, useState } from "react";
import {
  Button,
  Typography,
  Form,
  Select,
  Input,
  Tag,
  notification,
} from "antd";
import { get } from "../../../api/axios";
import { Link } from "react-router-dom";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { checkPermission } from "../../control-sections/auth/ProtectedRoutes";
import { onChangeTableHelper } from "../../control-sections/helper/TableHelpers";
import TableComponent from "../../control-sections/helper/TableComponent";

const ListingsPortalMenu = () => {
  const { Title } = Typography;
  const [form] = Form.useForm();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingSearch, setLoadingSearch] = useState(false);

  const [total, setTotal] = useState(1);

  const columns = [
    {
      title: " Id",
      dataIndex: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Icon",
      render: ({ icon }) => (
        <>
          <img
            width={84}
            height={84}
            src={icon}
            alt=""
            style={{ objectFit: "cover", borderRadius: "12px" }}
          />
        </>
      ),
    },
    {
      title: "Icon Path",
      dataIndex: "icon_path",
    },
    {
      title: "Name Ar",
      dataIndex: "name_ar",
      sorter: (a, b) => a.name_ar - b.name_ar,
    },
    {
      title: "Name En",
      dataIndex: "name_en",
      sorter: (a, b) => a.name_en - b.name_en,
    },
    {
      title: "Navigation",
      dataIndex: "navigation",
    },
    {
      title: "Type",
      dataIndex: "type",
      sorter: (a, b) => a.type - b.type,
    },
    {
      title: "Order",
      dataIndex: "order",
      sorter: (a, b) => a.order - b.order,
    },
    {
      title: "Active",
      render: ({ is_active }) => (
        <>
          <Tag color={`${is_active ? "success" : "error"}`}>
            {String(is_active)}
          </Tag>
        </>
      ),
      sorter: (a, b) => a.is_active - b.is_active,
    },
  ];

  if (checkPermission("update-listing-menu")) {
    columns.push({
      title: "Actions",
      dataIndex: "id",
      render: (id) => (
        <div>
          {checkPermission("update-listing-menu") && (
            <Button className="btn btn-outline-warning btn-edit btn-sm p-0 me-3">
              <Link
                className="color-inherit text-decoration-none py-1 px-2 d-block"
                to={`/listings-portal-menus/edit/${id}`}
              >
                <EditOutlined />
              </Link>
            </Button>
          )}
        </div>
      ),
    });
  }

  useEffect(() => {
    get("listing-menus").then((res) => {
      setData(res.data.data);
      setTotal(res.data.meta.total);
      setLoading(false);
    });
  }, []);

  const [filterData, setFilterData] = useState({
    filter_key: "",
    filter_value: "",
  });

  const [sorter, setSorter] = useState({
    sort_by: "",
    order: "",
  });

  const handleFilterKey = (e) => {
    setFilterData({ ...filterData, filter_key: e });
  };

  const handleFilterVal = (e) => {
    setFilterData({ ...filterData, [e.target.id]: e.target.value });
  };

  const onFilter = (values) => {
    setLoadingSearch(true);

    get(
      `listing-menus?filter_key=${filterData.filter_key}&filter_value=${
        filterData.filter_value
      }${
        sorter.sort_by !== "" && sorter.sort_by !== undefined
          ? `&sort_by=${sorter.sort_by}`
          : ""
      }${sorter.order !== "" ? `&order=${sorter.order}` : ""}`
    )
      .then((res) => {
        setData(res.data.data);
        setTotal(res.data.meta.total);
        setLoadingSearch(false);
      })
      .catch((err) => {
        notification.error({
          message: "Error!",
          description: err.response.data.message,
        });
        setLoadingSearch(false);
      });
  };

  const clearSearch = () => {
    form.resetFields();
    setFilterData({
      filter_key: "",
      filter_value: "",
    });
    get("listing-menus").then((res) => {
      setData(res.data.data);
      setTotal(res.data.meta.total);
    });
  };

  const onChangeTable = (pagination, filters, sorter) => {
    setLoading(true);
    setSorter({
      ...sorter,
      sort_by: sorter.field,
      order: sorter.order == "descend" ? "desc" : "asc",
    });

    onChangeTableHelper("listing-menus", pagination, filterData, sorter)
      .then((res) => {
        setData(res.data.data);
        setTotal(res.data.meta.total);
        setLoading(false);
      })
      .catch((err) => {
        notification.error({
          message: "Error!",
          description: err.response.data.message,
        });
        setLoading(false);
      });
  };

  return (
    <div>
      <div className="row">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-6 col-lg-4">
              <Title level={2} className="text-main mb-2">
                Listings Portal Menus
              </Title>
            </div>
          </div>
        </div>
      </div>

      <div className="grid-margin stretch-card wrapper-content">
        <Form onFinish={onFilter} layout="vertical" form={form}>
          <div className="row">
            <div className="col-12 col-lg-4">
              <Form.Item
                label="Search By"
                name="filter_key"
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Select
                  className="w-100"
                  showSearch
                  placeholder="select test "
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  onChange={handleFilterKey}
                  options={[
                    {
                      value: "type",
                      label: "Type",
                    },
                  ]}
                />
              </Form.Item>
            </div>
            <div className="col-12 col-lg-6">
              <Form.Item
                label="Search"
                name="filter_value"
                onChange={handleFilterVal}
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Input placeholder="Type to search..." />
              </Form.Item>
            </div>
            <div className="col-12 col-lg-2 d-flex align-items-end">
              <Form.Item className="w-100">
                <div className="row">
                  <div className="col-8">
                    <Button
                      block
                      loading={loadingSearch}
                      type="primary"
                      htmlType="submit"
                    >
                      {loadingSearch ? "Searching" : "Search"}
                    </Button>
                  </div>
                  <div className="col-4">
                    <Button
                      onClick={clearSearch}
                      className="flex-center"
                      danger
                      type="primary"
                    >
                      <DeleteOutlined />
                    </Button>
                  </div>
                </div>
              </Form.Item>
            </div>
          </div>
        </Form>
        <TableComponent
          onChangeTable={onChangeTable}
          loading={loading}
          columns={columns}
          data={data}
          total={total}
        />
      </div>
    </div>
  );
};

export default ListingsPortalMenu;
